module.exports = __webpack_public_path__ + "static/media/46.0329a716.jpg";